import NotificationService from "../services/notification.service";
import Config from "@/config/config.js";


/**
 * Frontend controller pour récupérer les notifications d’un utilisateur.
 * @param {string} userId – L’identifiant de l’utilisateur (UUID ou DID).
 * @returns {Promise<object>} – Liste des notifications ou une erreur normalisée.
 */
const getUserNotifications = async (userId) => {
    console.log("=== getUserNotifications === notification.controller.js === key: 441186 ===");
    console.log("→ userId reçu:", userId);
    console.log("=================================");
  
    try {
      const response = await NotificationService.getUserNotifications(userId);
  
      console.log("=== Réponse backend === notification.controller.js === key: 441188 ===");
      console.dir(response, { depth: null, colors: true });
      console.log("=================================");
  
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Erreur dans getUserNotifications controller:", error);
      return {
        success: false,
        message: "Erreur lors de la récupération des notifications",
        fromError: !Config.IN_PROD ? error.message : null,
        errorCode: "get-notifications-controller-error",
        errorKey: 441189,
      };
    }
  };
  /**
 * Frontend controller pour marquer les notifications comme lues.
 * @param {string[]} notificationIds – Liste des IDs de notifications.
 * @param {string} userId – ID de l’utilisateur.
 * @returns {Promise<object|null>} – Résultat de l’opération ou erreur normalisée.
 */
const markNotificationsAsRead = async (notificationIds, userId) => {
  console.log("=== markNotificationsAsRead === notification.controller.js === key: 441190 ===");
  console.log("→ notificationIds:", notificationIds);
  console.log("→ userId:", userId);
  console.log("=================================");

  if (!Array.isArray(notificationIds) || notificationIds.length === 0 || !userId) {
    console.warn("⚠️ Paramètres invalides pour markNotificationsAsRead");
    return {
      success: false,
      message: "Paramètres invalides",
      errorCode: "invalid-mark-as-read-params",
      errorKey: 441191,
    };
  }

  try {
    const response = await NotificationService.markNotificationsAsRead(notificationIds, userId);

    console.log("=== Réponse backend === notification.controller.js === key: 441192 ===");
    console.dir(response, { depth: null, colors: true });
    console.log("=================================");

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    console.error("Erreur dans markNotificationsAsRead controller:", error);
    return {
      success: false,
      message: "Erreur lors du marquage des notifications comme lues",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "mark-as-read-controller-error",
      errorKey: 441193,
    };
  }
};



const NotificationController = {
 
  getUserNotifications,
  markNotificationsAsRead,
};

export default NotificationController;